import * as angular from 'angular';

enum FinishPageState {
    CONFIRMATION_TIMEOUT,
    CONFIRMATION_REJECTED,
    CONFIRMATION_ACCEPTED
}

class StorageFcfsOfferFinishComponentCtrl implements ng.IController {
    public pageStateEnum = FinishPageState;
    public state: FinishPageState;

    constructor(private $window: ng.IWindowService) {}

    $onInit() {}

    public newBooking(): void {
        this.$window.location.reload();
    }
}

angular.module('app').component('pkpStorageFcfsOfferFinish', {
    controller: StorageFcfsOfferFinishComponentCtrl,
    template:
        require('app/storage-booking-wizard/storage-fcfs-offer-finish.component.html'),
    bindings: {
        offer: '=',
        response: '=',
        attachmentList: '=',
        ssoName: '=',
        state: '='
    }
});
